import { InputField } from "@risalabs_frontend_org/oasis-ui-kit";
import EditPencilIcon from "../../../../../shared/svg/editPencil";

interface SecretKeyFieldProps {
  error: string | undefined;
  isEditMode: boolean;
  isEditing: boolean;
  onEditClick: () => void;
  onChange: (value: string) => void;
  onBlur: () => void;
}

/**
 * TOTP/MFA secret-key input, structurally identical to `PasswordField`
 * but with secret-key-specific labels and hints. Kept as a separate
 * component (rather than parameterizing PasswordField) so the labels and
 * placeholders stay readable at the call site and grep-friendly.
 */
export const SecretKeyField = ({
  error,
  isEditMode,
  isEditing,
  onEditClick,
  onChange,
  onBlur,
}: SecretKeyFieldProps) => (
  <div className="flex w-full flex-row items-center gap-3">
    <div className="w-full">
      <InputField
        label="Secret Key"
        size="md"
        fullWidth
        type="password"
        required={!isEditMode || isEditing}
        hint={
          isEditMode
            ? "Click the pencil icon to overwrite the stored secret key."
            : "TOTP/MFA secret used to generate one-time codes. Will be encrypted."
        }
        error={error}
        defaultValue=""
        id="secret_key"
        readOnly={isEditMode && !isEditing}
        placeholder={
          isEditMode && !isEditing ? "••••••••••••••••" : "Enter secret key"
        }
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
    </div>
    {isEditMode && (
      <div className="mt-5 cursor-pointer" onClick={onEditClick}>
        <EditPencilIcon height={20} width={20} />
      </div>
    )}
  </div>
);
